// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-target {
  margin: 0;
}

.hero {
  display: flex;
  flex-flow: row;
  flex: 1;
  align-self: center;
  align-items: center;
}

.title {
  font-size: 6rem;
  text-transform: uppercase;
  margin: 0 0 1rem 0;
}

.wrapper {
  display: flex;
  flex-flow: column wrap;
}

@media screen and (max-width: 800px) {
  .title {
    font-size: 3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/home.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,OAAO;EACP,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".content-target {\n  margin: 0;\n}\n\n.hero {\n  display: flex;\n  flex-flow: row;\n  flex: 1;\n  align-self: center;\n  align-items: center;\n}\n\n.title {\n  font-size: 6rem;\n  text-transform: uppercase;\n  margin: 0 0 1rem 0;\n}\n\n.wrapper {\n  display: flex;\n  flex-flow: column wrap;\n}\n\n@media screen and (max-width: 800px) {\n  .title {\n    font-size: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
